import React, {useState} from 'react'
import Button from '@components/Button'
import ErrorBox from '@components/ErrorBox'
import SuccessBox from '@components/SuccessBox'
import logger from '@helpers/logger'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import Loading from '@packages/justo-parts/lib/components/Loading'
import {useMutate} from 'apollo-hooks'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {Field} from 'simple-react-form'

export default function RecoverPassword(props: {activeLoyalty: any; email: string}) {
  const {activeLoyalty, email} = props

  const [loading, setLoading] = useState<boolean>(false)
  const [applyNewPassword, setApplyNewPassword] = useState<boolean>(false)
  const [applyPasswordSuccesful, setApplyPasswordSuccesful] = useState<boolean>(null)
  const [errors, setErrors] = useState<string>()
  const [recoverPasswordCredentials, setRecoverPasswordCredentials] = useState<{
    token: string
    password: string
  }>({token: '', password: ''})

  const {spoonityRecoverPasswordVersion} = useQuery({
    query: gql`
      query spoonityRecoverPasswordVersion {
        spoonityRecoverPasswordVersion
      }
    `,
    variables: {}
  })

  const mutate = useMutate()

  async function sendRecoverPassword() {
    try {
      setLoading(true)
      await mutate({
        mutation: gql`
          mutation sendRecoverPassword($email: String) {
            spoonityRecoverPassword(email: $email)
          }
        `,
        variables: {email}
      })
      if (spoonityRecoverPasswordVersion) {
        setApplyPasswordSuccesful(null)
        setApplyNewPassword(true)
      }
    } catch (error) {
      logger.error('error sending recover password spoonity', {activeLoyalty, email})
    } finally {
      setLoading(false)
    }
  }

  async function recoverPasswordApply() {
    try {
      setErrors(null)
      setLoading(true)
      const {spoonityRecoverPasswordApply} = await mutate({
        mutation: gql`
          mutation recoverPasswordApply($token: String, $password: String) {
            spoonityRecoverPasswordApply(token: $token, password: $password)
          }
        `,
        variables: {...recoverPasswordCredentials}
      })

      if (!spoonityRecoverPasswordApply) {
        setErrors('Hubo un problema cambiando la contraseña, contacta con el local')
        return
      }
      setApplyPasswordSuccesful(true)
    } catch (error) {
      logger.error('error recover password apply spoonity', {
        error: error?.message,
        activeLoyalty,
        email,
        token: recoverPasswordCredentials.token
      })
      setErrors(error?.message)
    } finally {
      setLoading(false)
    }
  }

  function renderContent() {
    if (applyPasswordSuccesful) {
      return (
        <>
          <br />
          <SuccessBox message={`Se cambió la contraseña exitosamente`} style={{}} />
        </>
      )
    }
    return (
      <>
        <Field
          fieldName="token"
          type={Text}
          value={recoverPasswordCredentials.token}
          label="Código de verificación"
          onChange={token => setRecoverPasswordCredentials({...recoverPasswordCredentials, token})}
        />
        <Field
          fieldName="password"
          type={Text}
          value={recoverPasswordCredentials.password}
          label="Nueva contraseña"
          onChange={password =>
            setRecoverPasswordCredentials({...recoverPasswordCredentials, password})
          }
        />
        <Button
          fullWidth
          primary
          onClick={async () => {
            await recoverPasswordApply()
          }}
          disabled={!recoverPasswordCredentials.token || !recoverPasswordCredentials.password}
          loading={loading}>
          Recuperar
        </Button>
      </>
    )
  }

  if (loading) {
    return (
      <div className="text-center">
        <Loading />
      </div>
    )
  }

  return (
    <>
      <div
        //className={styles.recoverLink}
        className="text-blue-600 text-center cursor-pointer"
        onClick={async () => {
          await sendRecoverPassword()
        }}>{`Recuperar contraseña`}</div>
      {applyNewPassword ? renderContent() : null}
      {errors ? (
        <>
          <br />
          <ErrorBox message={'Hubo un problema cambiando la contraseña'} style={{}} />
        </>
      ) : null}
    </>
  )
}
